"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChevronLeft = void 0;
var React = require("react");
exports.ChevronLeft = (React.createElement("svg", { version: "1.1", xmlns: "http://www.w3.org/2000/svg", x: "0px", y: "0px", viewBox: "0 0 24 24", enableBackground: "new 0 0 200 200", xmlSpace: "preserve" },
    React.createElement("g", null,
        React.createElement("polygon", { transform: "translate(11.469500, 11.646500) scale(1, -1) rotate(90.000000) translate(-11.469500, -11.646500) ", points: "17.116 8.116 11.469 13.763 5.824 8.116 5.116 8.823 11.469 15.177 17.823 8.823" }))));
//# sourceMappingURL=ChevronLeft.js.map